<p>commonpage works!</p>
{{dataReceive}}